import { isNLW } from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";

class MediaFile {
    static getMediaType(media) {
        if(!media) return;
        
        if (media.indexOf("video") !== -1 || media.indexOf("sourcevideo") !== -1) {
            return 'video';
        }
        if (media.indexOf("pictures") !== -1 && media.indexOf("video") === -1) {
            return 'pictures';
        }

        if (((media.indexOf("pictures") === -1 && media.indexOf("video") === -1 && media.indexOf("audio") === -1) && isNLW()) ||
            ((media.indexOf("pictures") === -1 && media.indexOf("video") === -1) && !isNLW())) {
            return 'other';
        }

        if ((media.indexOf("audio") !== -1) && isNLW()) {
            return 'audio';
        }

    }

    static shouldShow(media, filter) {
        if (filter.indexOf(MediaFile.getMediaType(media)) > -1) {
            return true;
        }
        return false;
    }

    static getFileExtention(fname) {
        return fname ? fname.slice((fname.lastIndexOf(".") - 1 >>> 0) + 2).toLowerCase() : null;
    }

    static getFileIcon(fname) {
        const icons = { doc: 'file-word', docx: 'file-word', xls: 'file-excel', xlsx: 'file-excel', wav: 'music', mp3: 'music', wma: 'music', ogg: 'music', pdf: 'file-pdf' }
        if (icons.hasOwnProperty(MediaFile.getFileExtention(fname))) {
            return icons[MediaFile.getFileExtention(fname)];
        }
        return 'file';
    }

    static formatBytes(bytes) {
        return (bytes / 1000000).toFixed(2) + ' MB';
    }

    static isAudio(fname) {
        const formats = ['mp3', 'wav', 'ogg'];
        return formats.indexOf(MediaFile.getFileExtention(fname)) !== -1;
    }
	
	static isVideo(mediafile) {
        return mediafile && mediafile.videocodec;
    }
	
	static isImage(mediafile) {
        return mediafile && mediafile.height && mediafile.width && !mediafile.videocodec;
    }
	
	static hasFileExtention(fname) {
		return MediaFile.getFileExtention(fname) ? true : false;
	}

    static getAudioMIME(fname) {
        const mime = { mp3: 'audio/mpeg', wav: 'audio/wav', ogg: 'audio/ogg' };
        return mime[MediaFile.getFileExtention(fname)];
    }

    static getInformation(file) {
        let info = [];
        let ext = file.getFilename().split('.').pop().toLowerCase();

        info.push((file.width && file.height) ? (file.width + "x" + file.height) : "-");
        info.push(file.filesize ? MediaFile.formatBytes(file.filesize) : "-");
        info.push(file.aspect_ratio || "-");
        info.push(ext || "-");

        return info.join(' | ');
    }
}

export default MediaFile;
